var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-box"},[_c('img',{attrs:{"src":"/data-empty.png"}}),_c('span',[_vm._v("数据为空")])])
}]

export { render, staticRenderFns }